<template>
  <div class="answer mx-lg-4 mt-lg-4 mx-md-2 mt-md-2">
    <label class="h2 mb-1">{{ $t('labels.speech-answer') }}</label>
    <div
      v-for="(ans, ai) of question.answers"
      :key="ai"
      class="border border-2 mb-2 pt-1 pl-1 pr-1 pb-1 border-speech"
    >
      <b-row>
        <b-col md="9">
          <AudioRecorder :src="ans.extra_file && ans.extra_file !== 'null' ? ans.extra_file : ans.text"
                         :only-icon="true"
                         :include-graph="true"
                         class="problem-audio"
          >{{ ans.text }}</AudioRecorder>
        </b-col>
        <b-col v-if="ans.file"
               md="3"
        >
          <b-img
            v-if="ans.file"
            v-image-preview
            :src="ans.file"
            style="height:150px; width:190px;object-fit: contain;"
            class="img-fluid"
          />
        </b-col>
      </b-row>
      <b-form-textarea
        class="mt-2"
        placeholder="Write your thoughts"
        rows="8"
        @input="a => {
          $emit('updateAnswer', { answer: a, ansObject: ans })
        }"
      />
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BImg, BFormTextarea,
} from 'bootstrap-vue'
import AudioRecorder from '@/views/common/components/AudioPlayer.vue'

export default {
  name: 'ProblemWithConservation',
  components: {
    BRow,
    BCol,
    BImg,
    BFormTextarea,
    AudioRecorder,
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
}
</script>
